import styled from 'styled-components'

import { ImageIcon } from 'components/common/atoms'

import { locationPinIcon } from './constants'

const InfoWindow = styled.div`
  transform: translateX(-50%);
  left: 50%;
  position: absolute;
  top: -30px;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 5px 10px;

  height: 26px;
  font-family: 'Poppins';
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  background-color: #ffffff;
  white-space: nowrap;
  color: black;
  font-size: 12px;
  line-height: 16px;

  display: none;

  &.active {
    display: block;
  }
`
const MarkerBubble = styled.div`
  /* Position the bubble centred-above its parent. */
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -100%);

  /* Style the bubble. */
  width: fit-content;
  color: white;
  cursor: pointer;

  .iconMarker {
    transform: translateX(-50%);
    left: 50%;
    position: absolute;
    top: 20%;
  }
`
interface IMarkerIcon {
  iconClassName: string
  name: string
  infoId: string
}

export const MarkerIcon = ({ iconClassName, name, infoId }: IMarkerIcon) => (
  <MarkerBubble>
    <ImageIcon $width="24px" $height="36px" src={locationPinIcon} />
    <i className={`iconMarker ${iconClassName}`} />
    <InfoWindow id={infoId}>{name}</InfoWindow>
  </MarkerBubble>
)
